import { TripField } from "../select/TripField";
import { safeFormatDateTime } from "@/utils/formatDate";
import { Separator } from "@/components/ui/separator";
import { ArrowRight } from "lucide-react";

type ItineraryCardProps = {
  routeName: string;
  departureDate?: string;
  departureTime?: string;
  returnDate?: string;
  returnTime?: string;
};

export function ItineraryCard({
  routeName,
  departureDate,
  returnDate,
}: ItineraryCardProps) {
  return (
    <section className="px-4 py-6 md:p-6 rounded-2xl bg-card shadow-xl">
      <h2 className="text-secondary-foreground text-sm font-semibold flex items-center gap-1">
        <span className="flex items-center gap-2">
          {routeName?.split("-").map((part, index, parts) => (
            <span key={part} className="flex items-center gap-2">
              <span>{part.trim()}</span>

              {index < parts.length - 1 && (
                <ArrowRight className="h-4 w-4 shrink-0" />
              )}
            </span>
          ))}
        </span>
      </h2>

      <div className="mt-4 flex items-stretch gap-4">
        {/* TripField components for Departure and Return dates */}
        <TripField
          label="Departure"
          value={safeFormatDateTime(departureDate)}
        />
        {returnDate ? (
          <>
            <Separator orientation="vertical" className="h-auto" />
            <TripField
              label="Return"
              value={safeFormatDateTime(returnDate)}
            />
          </>
        ) : null}
      </div>
    </section>
  );
}
